<template>
  <a-card>
    <div
      style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px"
    >
      <WarningOutlined v-if="props.rules.length === 0" class="text-error" />
      <a-typography-title
        :level="4"
        style="margin: 0"
        :class="props.rules.length === 0 ? 'text-error' : ''"
      >
        {{ props.type.description }}
      </a-typography-title>
      <a-typography-text v-if="!props.loading" type="secondary">
        {{ props.rules.length }} regla(s)
      </a-typography-text>
    </div>
    <div v-if="props.loading">
      <a-skeleton active :title="false" :paragraph="{ rows: 2 }" />
    </div>
    <div v-else style="display: flex; flex-direction: column; gap: 8px">
      <div v-for="rule in props.rules" :key="rule.id">
        <NotificationRule
          :rule="rule"
          :action-loading="props.actionLoading"
          @edit="handleEdit"
          @delete="handleDelete"
        />
      </div>
    </div>
  </a-card>
</template>

<script setup>
import { WarningOutlined } from '@ant-design/icons-vue';
import NotificationRule from './notification-rule.vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  type: {
    type: Object,
    required: true
  },
  rules: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  actionLoading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['edit', 'delete']);

const handleEdit = (rule) => {
  emit('edit', rule);
};

const handleDelete = (rule) => {
  emit('delete', rule);
};
</script>
